import { render, staticRenderFns } from "./LayoutCentralized.vue?vue&type=template&id=189533f6&scoped=true&"
import script from "./LayoutCentralized.vue?vue&type=script&lang=js&"
export * from "./LayoutCentralized.vue?vue&type=script&lang=js&"
import style0 from "./LayoutCentralized.vue?vue&type=style&index=0&id=189533f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189533f6",
  null
  
)

export default component.exports